// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1fvdglyw button:not([disabled]):after{border:none}._19bvu2gc{padding-left:var(--ds-space-100,8px)}\n._1e0c1txw{display:flex}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._gy1pv77o{column-gap:var(--ds-space-025,2px)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._p12f1q5e{max-width:var(--_4v9t68)}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
